module.exports = __webpack_public_path__ + "img/helpQue.d1afa1ff.png";